import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, Teleport as _Teleport, withKeys as _withKeys, createElementVNode as _createElementVNode } from "vue"

import { ref, watch, nextTick, onMounted, onBeforeUnmount, type CSSProperties } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AutoComplete',
  props: /*@__PURE__*/_mergeModels({
    completions: {}
  }, {
    "modelValue": { default: '' },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const showSelection = ref(false)
const inputField = ref<InstanceType<any> | null>(null)
const autocompleteContainer = ref<HTMLDivElement | null>(null)
const dropdownStyle = ref<CSSProperties>({})

const query = _useModel<string>(__props, "modelValue")

const props = __props

const suggestions = ref<string[]>([])
const selectedIndex = ref(-1)

function updateDropdownPosition(): void {
  if (!autocompleteContainer.value) return

  const rect = autocompleteContainer.value.getBoundingClientRect()
  dropdownStyle.value = {
    position: 'fixed',
    top: `${rect.bottom}px`,
    left: `${rect.left}px`,
    width: `${rect.width}px`,
    maxHeight: '200px',
    overflowY: 'auto',
    zIndex: 9999
  }
}

function onFocus(): void {
  showSelection.value = true
  updateDropdownPosition()
}

function onBlur(): void {
  setTimeout(() => {
    showSelection.value = false
  }, 150)
}

function handleScrollOrResize(): void {
  if (showSelection.value) {
    updateDropdownPosition()
  }
}

onMounted(() => {
  window.addEventListener('scroll', handleScrollOrResize, true)
  window.addEventListener('resize', handleScrollOrResize)
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScrollOrResize, true)
  window.removeEventListener('resize', handleScrollOrResize)
})

watch(query, (val) => {
  if (val) {
    fetchSuggestions(val)
  } else {
    suggestions.value = []
    selectedIndex.value = -1
  }
})

watch(showSelection, (val) => {
  if (val) {
    nextTick(() => updateDropdownPosition())
  }
})

function fetchSuggestions(q: string): void {
  const allSuggestions = [q, ...(props.completions ?? [])]
  suggestions.value = allSuggestions.filter(s => s.toLowerCase().includes(q.toLowerCase()))
  selectedIndex.value = 0
}

function moveSelection(direction: number): void {
  if (!suggestions.value.length) return
  selectedIndex.value =
    (selectedIndex.value + direction + suggestions.value.length) % suggestions.value.length
}

function selectSuggestion(index: number = selectedIndex.value): void {
  if (index >= 0 && suggestions.value[index]) {
    query.value = suggestions.value[index]
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, {
    justify: "center",
    class: "mb-4",
    width: "100%"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            ref_key: "autocompleteContainer",
            ref: autocompleteContainer,
            style: {"position":"relative","width":"100%"},
            onKeydown: [
              _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (moveSelection(1)), ["prevent"]), ["down"])),
              _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (moveSelection(-1)), ["prevent","stop"]), ["up"])),
              _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (selectSuggestion()), ["prevent","stop"]), ["enter"]))
            ]
          }, [
            _createVNode(_component_v_text_field, {
              ref_key: "inputField",
              ref: inputField,
              modelValue: query.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event)),
              onFocus: onFocus,
              onInput: _cache[1] || (_cache[1] = ($event: any) => (showSelection.value = true)),
              onBlur: onBlur,
              type: "text",
              placeholder: "Search...",
              style: {"width":"100%","height":"2.5rem"}
            }, null, 8, ["modelValue"]),
            (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
              _withDirectives(_createVNode(_component_v_list, {
                class: "autocomplete-dropdown elevation-8",
                style: _normalizeStyle(dropdownStyle.value)
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestions.value, (suggestion, index) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      key: index,
                      class: _normalizeClass(['suggestion', { selected: index === selectedIndex.value }]),
                      onMousedown: _withModifiers(($event: any) => {selectSuggestion(index); showSelection.value = false}, ["prevent"])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, {
                          textContent: _toDisplayString(suggestion)
                        }, null, 8, ["textContent"])
                      ]),
                      _: 2
                    }, 1032, ["class", "onMousedown"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["style"]), [
                [_vShow, showSelection.value && suggestions.value.length > 0]
              ])
            ]))
          ], 544)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})